module.exports = __webpack_public_path__ + "img/mapi.82f76d09.png";